import { useEffect, useState } from "react";

import { methodMap } from "../services/BitmakerApp";

import { useApiError } from "./useApiError";

export function useNextInvoiceNumber(invoiceId: string | undefined) {
  const { handleAPIError } = useApiError();

  const [nextInvoiceNumber, setNextInvoiceNumber] = useState<string | null>(
    null,
  );
  const [loadingNextInvoiceNumber, setLoadingNextInvoiceNumber] =
    useState(false);
  const [fetchNextInvoiceNumberError, setFetchNextInvoiceNumberError] =
    useState<string | null>(null);

  const isExistingInvoice = !!invoiceId;

  useEffect(() => {
    // Only fetch when creating a new invoice
    if (isExistingInvoice) {
      setNextInvoiceNumber(null);
      setLoadingNextInvoiceNumber(false);
      setFetchNextInvoiceNumberError(null);
      return;
    }

    let isCancelled = false;

    setLoadingNextInvoiceNumber(true);
    setFetchNextInvoiceNumberError(null);

    methodMap.get("/billing/invoices/next-number", null, (response) => {
      if (isCancelled) return;

      const { isError, message } = handleAPIError(response);

      setLoadingNextInvoiceNumber(false);

      if (isError) {
        console.error("Error fetching next invoice number:", message);
        setFetchNextInvoiceNumberError(
          "Error fetching next invoice number. Please try again.",
        );
        return;
      }

      setNextInvoiceNumber(response.data.nextNumber);
    });

    return () => {
      isCancelled = true;
    };
  }, [isExistingInvoice, handleAPIError]);

  return {
    nextInvoiceNumber,
    loadingNextInvoiceNumber,
    fetchNextInvoiceNumberError,
  };
}
